// newhome_navbar.js

(function () {
  var items = document.querySelectorAll('.container-navbar-grey ul li');
  if (!items.length) {
    // No hay elementos, no hacemos nada
    return;
  }

  // Aseguramos que haya siempre un elemento activo inicial
  var activeItem = document.querySelector('.container-navbar-grey ul li.active');
  if (!activeItem) {
    items[0].classList.add('active');
  }

  setInterval(function () {
    var current = document.querySelector('.container-navbar-grey ul li.active');

    if (!current) {
      // Fallback: si se perdió la clase por algún motivo, reactivo el primero
      items[0].classList.add('active');
      return;
    }

    current.classList.remove('active');

    var next = current.nextElementSibling;
    if (!next || !next.matches('li')) {
      next = items[0];
    }

    if (next) {
      next.classList.add('active');
    }
  }, 3000); // cambia el activo cada 3s
})();
